export default "https://assets-v2.scaler.com/packs/images/SPOJ.9d7347.svg";